export default "__VITE_ASSET__B1217R9T__"